import React, { useId } from 'react'

/**
 * Multi-line text input. Same composite shape as TextField.
 */
export function TextArea({
  label,
  value,
  onChange,
  placeholder,
  disabled = false,
  required = false,
  error,
  readOnly = false,
  rows = 3,
  resize = 'vertical',
  id,
  className = '',
  ...rest
}) {
  const generatedId = useId()
  const inputId = id || generatedId
  const errorId = `${inputId}-error`
  const hasError = Boolean(error)
  return (
    <div className={['field', className].filter(Boolean).join(' ')}>
      {label ? (
        <label
          className="label"
          htmlFor={inputId}
          data-required={required || undefined}
        >
          {label}
        </label>
      ) : null}
      <textarea
        id={inputId}
        className="textarea"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        readOnly={readOnly}
        rows={rows}
        style={{ resize }}
        data-readonly={readOnly || undefined}
        aria-required={required || undefined}
        aria-invalid={hasError || undefined}
        aria-describedby={hasError ? errorId : undefined}
        {...rest}
      />
      {hasError ? (
        <span id={errorId} role="status" className="field-error">
          {error}
        </span>
      ) : null}
    </div>
  )
}
